import { ActivityZoneType, EasterCategory } from "./../enums/holiday";
import {
  SPRING_SPRING_PICKS,
  SPRING_NEW_PICKS,
  SPRING_WOMEN_SWEAR,
  SPRING_BEAUTY,
  SPRING_PHONES,
  SPRING_HOME,
  SPRING_RANK_BANNER,
} from "@/cdn-resources/spring";
import type {
  THolidayCategory,
  DataRulesItem,
  ActiveDataInfo,
  EHolidayRuleInfo,
  EHolidayClassNameInfo,
  HolidayRankBannerInfo,
} from "@/shared/entitys/holiday";
import { EHolidayType, SpringCategory } from "@/shared/enums/holiday";
import { fetchHolidayProductList } from "@/api/holiday";
import { fetchProductSearchV3 } from "@/api/black5";
import { TableColumnProps } from "@arco-design/web-react";
import { AdvBannerType, SubCategoryType, TrackingEventPageID } from "../enums";
import { EASTER_FINDS, EASTER_RANK_BANNER } from "@/cdn-resources/easter";

export const SpringCategoryList: THolidayCategory = [
  {
    name: "Spring Picks",
    type: SpringCategory.Spring,
    iconSrc: SPRING_SPRING_PICKS,
    fetchApi: fetchHolidayProductList,
    activityZoneType: ActivityZoneType.SpringPicks,
  },
  {
    name: "New Picks",
    type: SpringCategory.New,
    iconSrc: SPRING_NEW_PICKS,
    fetchApi: fetchHolidayProductList,
    activityZoneType: ActivityZoneType.NewPicks,
  },
  {
    name: "Womenswear&",
    subtitle: "Underwear",
    type: SpringCategory.Womenwear,
    iconSrc: SPRING_WOMEN_SWEAR,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Womenwear,
  },
  {
    name: "Beauty& ",
    subtitle: "Personal Care",
    type: SpringCategory.Beaut,
    iconSrc: SPRING_BEAUTY,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Beaut,
  },
  {
    name: "Home Supplies",
    type: SpringCategory.Home,
    iconSrc: SPRING_HOME,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Home,
  },
  {
    name: "Phones& ",
    subtitle: "Electronics",
    type: SpringCategory.Phones,
    iconSrc: SPRING_PHONES,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Phones,
  },
];

export const EasterCategoryList: THolidayCategory = [
  {
    name: "Eggcellent Finds",
    type: EasterCategory.Easter,
    iconSrc: EASTER_FINDS,
    fetchApi: fetchHolidayProductList,
    activityZoneType: ActivityZoneType.EggcellentFinds,
  },
  {
    name: "New Picks",
    type: EasterCategory.EasterNew,
    iconSrc: SPRING_NEW_PICKS,
    fetchApi: fetchHolidayProductList,
    activityZoneType: ActivityZoneType.NewPicks,
  },
  {
    name: "Womenswear&",
    subtitle: "Underwear",
    type: EasterCategory.EasterWomenwear,
    iconSrc: SPRING_WOMEN_SWEAR,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Womenwear,
  },
  {
    name: "Beauty& ",
    subtitle: "Personal Care",
    type: EasterCategory.EasterBeaut,
    iconSrc: SPRING_BEAUTY,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Beaut,
  },
  {
    name: "Home Supplies",
    type: EasterCategory.EasterHome,
    iconSrc: SPRING_HOME,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Home,
  },
  {
    name: "Phones& ",
    subtitle: "Electronics",
    type: EasterCategory.EasterBeautPhones,
    iconSrc: SPRING_PHONES,
    fetchApi: fetchProductSearchV3,
    categoryId: SubCategoryType.Phones,
  },
];

export const HolidayCategoryMap: Record<EHolidayType, THolidayCategory> = {
  [EHolidayType.Spring]: SpringCategoryList,
  [EHolidayType.Easter]: EasterCategoryList,
};

export const HolidayByTrackingPageIdMap: Record<
  EHolidayType,
  TrackingEventPageID
> = {
  [EHolidayType.Spring]: TrackingEventPageID.Spring,
  [EHolidayType.Easter]: TrackingEventPageID.Easter,
};

export const RulesTime = "February 25, 00:00 - April 05, 23:59 (Pacific Time)";
export const PaymentTime =
  "Based on orders completed by 11:59 PM Pacific Time on MAY 31. 2025";

export const EasterRulesTime = "April 10, 00:00 - May 10, 23:59 (Pacific Time)";
export const EasterPaymentTime =
  "Based on orders completed by 11:59 PM Pacific Time on June 31. 2025";

export const DataRules: DataRulesItem[] = [
  {
    key: "1",
    rank: "1",
    requirement: "GMV>$80000 In Yoofinds",
    price: "$3000",
  },
  {
    key: "2",
    rank: "2-10",
    requirement: "GMV>$30000 In Yoofinds",
    price: "$1000",
  },
  {
    key: "3",
    rank: "11-30",
    requirement: "GMV>$15000 In Yoofinds",
    price: "$500",
  },
];

export const ColumnsRules: TableColumnProps[] = [
  {
    title: "Rank",
    dataIndex: "rank",
    align: "center",
  },
  {
    title: "Requirement",
    dataIndex: "requirement",
    align: "center",
  },
  {
    title: "Prize",
    dataIndex: "price",
    align: "center",
  },
];

export const DataActiveB: ActiveDataInfo[] = [
  {
    key: "1",
    title: "50",
    value: "100",
  },
  {
    key: "2",
    title: "100",
    value: "150",
  },
  {
    key: "3",
    title: "500",
    value: "300",
  },
];

export const HolidayClassNameMap: Record<EHolidayType, EHolidayClassNameInfo> =
  {
    [EHolidayType.Spring]: {
      rulesContentClassName:
        "bg-mintFrost shadow-[0px_2px_15px_0px_rgba(0,0,0,0.1)]",
      productContentClassName: "",
      checkButtonClassName:
        "bg-mintFrost border border-[#009C70] text-[#009C70]",
      collapseButtonFill: "#009c70",
      categoryIconDefaultClassName: "",
      categoryIconActiveClassName: "border-[#009c70]",
      categoryTextDefaultClassName: "",
      categoryTextActiveClassName: "text-[#009C70]",
    },
    [EHolidayType.Easter]: {
      rulesContentClassName:
        "bg-white shadow-[0px_2px_15px_0px_rgba(0,0,0,0.1)]",
      productContentClassName: "",
      checkButtonClassName: "bg-neonMagenta text-white",
      collapseButtonFill: "#172358",
      categoryIconDefaultClassName: "border-[#D1E8FF]",
      categoryIconActiveClassName: "border-[#C02ED5]",
      categoryTextDefaultClassName: "",
      categoryTextActiveClassName: "text-[#C02ED5]",
    },
  };

export const HolidayRulesMap: Record<EHolidayType, EHolidayRuleInfo> = {
  [EHolidayType.Spring]: {
    activityPeriod: "Feb. 25, 2025--Apr. 05, 2025",
    earnCampaign: "$1,000,000 Budget For Running Ads",
    winChallenge: "Sell 50, Get $100；Sell 100, Get $150；Sell 500, Get $300",
    topSellerPrize: "1st place wins an extra $3000.",
  },
  [EHolidayType.Easter]: {
    activityPeriod: "Apr. 10, 2025 – May 10, 2025",
    earnCampaign: "$1,000,000 Budget For Running Ads",
    winChallenge: "Sell 50, Get $100；Sell 100, Get $150；Sell 500, Get $300",
    topSellerPrize: "1st place wins an extra $3000.",
  },
};

export const HolidayCategoryType = {
  [EHolidayType.Spring]: SpringCategory,
  [EHolidayType.Easter]: EasterCategory,
};

export const HolidayBannerParamMap: Record<EHolidayType, AdvBannerType> = {
  [EHolidayType.Spring]: AdvBannerType.Spring,
  [EHolidayType.Easter]: AdvBannerType.Easter,
};

export const ActiveSpecialList = [
  SpringCategory.New,
  SpringCategory.Spring,
  EasterCategory.Easter,
  EasterCategory.EasterNew,
];

export const HolidayRankBannerMap: Record<EHolidayType, HolidayRankBannerInfo> =
  {
    [EHolidayType.Spring]: {
      className: "w-screen relative top-0 left-0 ml-[calc((100%-100vw)/2)]",
      imgSrc: SPRING_RANK_BANNER,
    },
    [EHolidayType.Easter]: {
      className: "w-full relative top-0 left-0 xxl:w-5/6 mx-auto pt-[20px]",
      imgSrc: EASTER_RANK_BANNER,
    },
  };

export const HolidayRankTextHighlightColor = {
  [EHolidayType.Spring]: "#ae322b",
  [EHolidayType.Easter]: "#FE2C55",
};
